module.exports = __webpack_public_path__ + "static/media/11_kestavat-kaupungit_en_US.e642865f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/11_kestavat-kaupungit_en_US.svg
// module id = ./src/images/agendaIcons/11_kestavat-kaupungit_en_US.svg
// module chunks = 1